var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Bar',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"chart-id":_vm.chartId},on:{"downlod":_vm.downloadImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }